import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lookupData: null,
  loading: false,
  error: null,
};

const lookupSlice = createSlice({
  name: "lookup",
  initialState,
  reducers: {
    fetchLookupStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLookupSuccess: (state, action) => {
      state.loading = false;
      state.lookupData = action.payload;
    },
    fetchLookupFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchLookupStart, fetchLookupSuccess, fetchLookupFailure } =lookupSlice.actions;

export default lookupSlice.reducer;
